module.exports = __webpack_public_path__ + "static/img/23-entrepreneurshipinnov.c820563.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-entrepreneurshipinnov.png
// module id = 3V1/
// module chunks = 1